import type { UserAvatarFragment } from "../client/generated";
import type { ComponentProps } from "react";
import { useProtectedImageSource } from "../client/images";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@acdc2/ui/components/avatar";

type Props = ComponentProps<typeof Avatar> & {
  fragment: UserAvatarFragment;
};

export function UserAvatar({ fragment, ...avatarProps }: Props) {
  const src = useProtectedImageSource(fragment.avatarUrl);

  return (
    <Avatar {...avatarProps}>
      <AvatarImage src={src} />
      <AvatarFallback>{fragment.username[0].toUpperCase()}</AvatarFallback>
    </Avatar>
  );
}
